import Actions from '@app/action';
import Store from '@app/store';

import Analytics from '@module/analytics';

import { AUTH_STATE } from '@constant/auth';

export const shouldAskBeforeLeaving = (route) =>
  route.unSavedForm || route.isMobileTransfer;

export function createOnRouteHandler(router) {
  return function handleOnRoute(route) {
    const { user } = Store.getState();

    if (route.requiredAuthState === AUTH_STATE.LOGGED_IN && !user.loggedIn) {
      router.resolve('/sign-in');
      Store.dispatch(Actions.Session.setRedirect(route.path));
      return;
    }

    if (route.requiredAuthState === AUTH_STATE.LOGGED_OUT && user.loggedIn) {
      router.resolve('/', true);
      return;
    }

    if (
      Array.isArray(route.planTiers) &&
      !route.planTiers.includes(user.planTier)
    ) {
      router.resolve('/', true);
      return;
    }

    // Record referral key for acqusition channel tracking
    Analytics.setReferralKey(location.search);

    // Record page view
    Analytics.pageView(route.path + location.search);

    // Update the Route in our store.
    Store.dispatch(Actions.Route.setRoute(route));
  };
}
